



























































































































































































































































































































































import Component, { mixins } from 'vue-class-component';
import { currencyFormat, loadView, loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import {
  IOrganizations,
  IPaginate,
  ISettlementReportGraphData,
  ISettlementReports,
  IStore,
  IUser,
} from '@/types/types';
import timestamp from '@/filters/timestamp';
import mediumZoom from 'medium-zoom';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import DialogMixins from '@/mixins/DialogMixins';
import moment from 'moment';
import qs from 'qs';
import CircularProgressLoader from '@/components/widgets/CircularProgressLoader.vue';
import FileUpload from '@/components/widgets/FileUpload.vue';
const settlementReportsModule = namespace('settlementReports');
const organizationModule = namespace('organizations');
const authModule = namespace('auth');
@Component({
  name: 'Transactions',
  components: {
    FileUpload,
    CircularProgressLoader,
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    GetDetails: loadView('pages/products/dialogs/GetDetails'),
    ReportGeneratorDialog: loadView('pages/products/dialogs/ReportGeneratorDialog'),
    SettlementReportPreviewDialog: loadView('pages/products/dialogs/SettlementReportPreviewDialog'),
  },
  filters: {
    currencyFormat,
    timestamp,
  },
})
export default class Transactions extends mixins(WidgetMixins, DialogMixins) {
  @settlementReportsModule.Getter('getAllSettlementReports') settlementReports!: ISettlementReports[];
  @settlementReportsModule.Getter('getPagination') pagination!: IPaginate;
  @settlementReportsModule.Getter('getSettlementReportGraphData') settlementReportGraphData!: Array<
    ISettlementReportGraphData
  >;
  @settlementReportsModule.Getter('getUserGeneratedSettlementReportList') userGeneratedList!: Array<ISettlementReports>;
  @settlementReportsModule.Getter('getGeneratedSettlementReportDates') generatedSettlementReportDates!: Array<string>;
  @settlementReportsModule.Getter('getGeneratedSettlementReportDetails')
  generatedSettlementReportDetails!: ISettlementReports;
  @settlementReportsModule.Getter('getTotalSettlementAmount') totalSettlementAmount!: number;

  @organizationModule.Getter('getAllOrganizations') organizations!: IOrganizations[];
  @authModule.Getter('getUserDetails') details!: IUser & IStore;

  menu: boolean = false;
  options: any = {};
  searchTerm: string | null = null;
  date: string | null = null;
  statuses: Array<string> = ['ALL', 'ON_HOLD', 'PENDING', 'COMPLETED'];
  query: string = '';
  generatedReportQuery: string = '';
  startDateMenu: boolean = false;
  endDateMenu: boolean = false;

  startDate: string | null = moment()
    .subtract(1, 'week')
    .format('YYYY-MM-DD');
  endDate: string | null = moment().format('YYYY-MM-DD');
  status: string | null = 'ALL';
  organizationId: string | null = null;
  tabs: number = 0;
  titles: string[] = ['All Reports', 'Generate Report'];
  selectedGeneratedReportDate: string | null = null;
  requestType = 'SYSTEM_GENERATED_REPORT';

  statusColors: { [key: string]: string } = {
    ON_HOLD: 'accent',
    PENDING: 'warning',
    COMPLETED: 'success',
  };

  settlementStatusClass(status: string): string {
    const classes: { [key: string]: string } = {
      ON_HOLD: 'ka-status--info',
      PENDING: 'ka-status--warning',
      COMPLETED: 'ka-status--success',
    };
    return classes[status] || 'ka-status--info';
  }
  headers: Array<{ text: string; value: string; align?: string }> = [
    {
      text: 'Date',
      value: 'date',
    },
    {
      text: 'Org.Name',
      value: 'organisationName',
    },
    {
      text: 'Total Amount',
      value: 'totalAmount',
    },
  ];

  chartBarOptions: any = {
    chart: {
      type: 'bar',
      height: 400,
      background: 'transparent',
      fontFamily: 'Hanken Grotesk, sans-serif',
      toolbar: { show: false },
    },
    colors: ['#FF0055'],
    legend: {
      fontFamily: 'Hanken Grotesk, sans-serif',
    },
    grid: {
      show: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: 'end',
        columnWidth: '55%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: (value: number) => this.compactAmount(value),
        style: { fontSize: '11px' },
      },
    },
    xaxis: {
      labels: {
        rotate: -45,
        trim: true,
        hideOverlappingLabels: true,
        style: { fontSize: '10px' },
      },
    },
    tooltip: {
      y: {
        formatter: (value: number) => `GHS ${Number(value || 0).toLocaleString('en', { maximumFractionDigits: 2 })}`,
      },
    },
  };

  compactAmount(value: number): string {
    const amount = Number(value || 0);
    if (amount >= 1000000) return `${(amount / 1000000).toFixed(1)}M`;
    if (amount >= 1000) return `${(amount / 1000).toFixed(0)}K`;
    return amount.toFixed(0);
  }

  get isDark(): boolean {
    return this.$vuetify.theme.dark;
  }

  @Watch('isDark', { immediate: true })
  onThemeChange(dark: boolean): void {
    this.chartBarOptions = {
      ...this.chartBarOptions,
      chart: { ...this.chartBarOptions.chart, foreColor: dark ? '#9AA3AE' : '#545D68', background: 'transparent' },
      theme: { mode: dark ? 'dark' : 'light' },
      tooltip: { ...this.chartBarOptions.tooltip, theme: dark ? 'dark' : 'light' },
      colors: [dark ? '#FF3D78' : '#FF0055'],
    };
  }

  settlementReportGraphCategories: string[] = [];
  series: Array<{ name: string; data: number[] }> = [];

  @Watch('selectedGeneratedReportDate')
  onSelectedGeneratedReportDateChange(value: string): void {
    let qParams = {
      ...qs.parse(this.query, { ignoreQueryPrefix: true }),
      startDate: value,
      endDate: value,
    };
    this.query = qs.stringify(qParams, { skipNulls: true, addQueryPrefix: true });
    this.$store.dispatch('settlementReports/list', this.query);
  }

  @Watch('tabs')
  onTabsChange(value: number): void {
    switch (value) {
      case 0: {
        this.requestType = 'SYSTEM_GENERATED_REPORT';
        const qParams = {
          ...qs.parse(this.query, { ignoreQueryPrefix: true }),
          organizationId: this.organizationId,
          startDate: this.startDate,
          endDate: this.endDate,
          requestType: this.requestType,
        };
        this.query = qs.stringify(qParams, { skipNulls: true, addQueryPrefix: true });
        this.$store.dispatch('settlementReports/list', this.query);
        return;
      }
      case 1: {
        this.requestType = 'USER_GENERATED_REPORT';
        const qParams = {
          ...qs.parse(this.query, { ignoreQueryPrefix: true }),
          requestType: this.requestType,
          startDate: this.selectedGeneratedReportDate,
          endDate: this.selectedGeneratedReportDate,
          organizationId: this.organizationId,
          status: this.status !== 'ALL' ? this.status : null,
        };
        this.query = qs.stringify(qParams, { skipNulls: true, addQueryPrefix: true });
        this.$store.dispatch('settlementReports/list', this.query);
        return;
      }
    }
  }

  @Watch('settlementReportGraphData')
  onSettlementReportGraphDataChange(value: Array<ISettlementReportGraphData>): void {
    if (this.organizationId !== null) {
      this.settlementReportGraphCategories = value.map(item => timestamp(item.date, 'YYYY-MM-DD'));
    } else {
      this.settlementReportGraphCategories = value.map((item: ISettlementReportGraphData) => item.organizationName);
    }
    this.series = [
      {
        name: 'Total Amount',
        data: value.map((item: ISettlementReportGraphData) => item.totalAmount),
      },
    ];
  }

  @Watch('organizationId')
  onOrganizationIdChange(value: string): void {
    let qParams = {
      ...qs.parse(this.query, { ignoreQueryPrefix: true }),
      organizationId: value,
    };
    this.query = qs.stringify(qParams, { skipNulls: true, addQueryPrefix: true });
    this.$store.dispatch('settlementReports/list', this.query);
  }

  @Watch('status')
  onStatusChange(value: string): void {
    let qParams = {
      ...qs.parse(this.query, { ignoreQueryPrefix: true }),
      status: value !== 'ALL' ? value : null,
    };
    this.query = qs.stringify(qParams, { skipNulls: true, addQueryPrefix: true });
    this.$store.dispatch('settlementReports/list', this.query);
  }

  @Watch('options', {
    deep: true,
  })
  onOptionsChange(paginate: IPaginate): void {
    const qParams = {
      page: paginate.page,
      size: paginate.itemsPerPage,
      organizationId: this.organizationId,
      startDate: this.requestType === 'SYSTEM_GENERATED_REPORT' ? this.startDate : this.selectedGeneratedReportDate,
      endDate: this.requestType === 'SYSTEM_GENERATED_REPORT' ? this.endDate : this.selectedGeneratedReportDate,
      requestType: this.requestType,
      status: this.status !== 'ALL' ? this.status : null,
    };
    this.query = qs.stringify(qParams, { skipNulls: true, addQueryPrefix: true });
    this.$store.dispatch('settlementReports/list', this.query);
  }

  @Watch('startDate')
  onStartDateChange(date: string): void {
    this.query = qs.stringify(
      { ...qs.parse(this.query, { ignoreQueryPrefix: true }), startDate: date },
      { skipNulls: true, addQueryPrefix: true },
    );
    this.$store.dispatch('settlementReports/list', this.query);
  }

  @Watch('endDate')
  onEndDateChange(date: string): void {
    this.query = qs.stringify(
      { ...qs.parse(this.query, { ignoreQueryPrefix: true }), endDate: date },
      { skipNulls: true, addQueryPrefix: true },
    );
    this.$store.dispatch('settlementReports/list', this.query);
  }

  downloadFile(ext: string): void {
    const query = this.query + `&download=true&ext=${ext}`;
    this.$store.dispatch('settlementReports/list', query);
  }

  handleSettlementReportGeneration(payload: {
    query: { startDate: string; endDate: string };
    loading: { idx: string; state: boolean };
  }): void {
    const { query, loading } = payload;
    this.$store.dispatch('settlementReports/generateReport', {
      body: {
        requestType: 'GENERATE_DATA',
      },
      loading,
      query: { ...query, organizationId: this.organizationId },
    });
  }

  uploadPaymentReceipt(payload: any): void {
    const { loading, body } = payload;
    this.$store.dispatch('settlementReports/uploadPaymentReceipt', {
      loading,
      id: this.generatedSettlementReportDetails._id,
      organizationId: this.generatedSettlementReportDetails.organisationId,
      body,
    });
  }

  saveGeneratedReport(payload: {
    query: { startDate: string; endDate: string };
    loading: { idx: string; state: boolean };
  }): void {
    const { query, loading } = payload;
    this.$store.dispatch('settlementReports/generateReport', {
      body: {
        generatedReports: this.userGeneratedList,
        requestType: 'PERSIST_DATA',
      },
      loading,
      query: { ...query, organizationId: this.organizationId },
    });
  }
  reportIdLoader: string | null = null;
  handleSettlementReportStatus(item: ISettlementReports): void {
    this.reportIdLoader = item._id;
    const status = Object.keys(this.statusColors)
      .filter(key => key !== 'COMPLETED')
      .find(key => key !== item.settlementStatus);
    const payload = {
      organizationId: item.organisationId,
      id: item._id,
      body: {
        status,
      },
      query: this.query,
    };
    this.$store.dispatch('settlementReports/updateSettlementReportStatus', payload);
  }

  downloadUploadedDocument(url: string): void {
    if (url.startsWith('https') || url.startsWith('http')) {
      new Blob([url], { type: 'text/plain' });
    }
  }

  created(): void {
    this.$store.dispatch('auth/me');
    this.$store.dispatch('organizations/list', false);
    this.$store.dispatch('settlementReports/fetchAllGeneratedReportDates');
  }
  mounted(): void {
    mediumZoom('.productPreview');
  }
}
